module.exports = __webpack_public_path__ + "img/tukangLogo.cd345fd5.png";